import React, { Component } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import numeral from 'numeral';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
);

class Sparkline extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef(null);

        const chartData = {
            labels: props.labels ?? props.dataL,
            datasets: [
                {
                    label: 'Sparkline',
                    data: props.dataL,
                    borderColor: '#33B1A5',
                    borderWidth: 2,
                    borderRadius: 4,
                    tension: 0.4,
                },
            ],
        };

        this.state = {
            chartData,
        };
    }

    componentDidMount() {
        // this is for adding gradient background
        setTimeout(() => {
            if (this.ref.current) {
                const chartInstance = this.ref.current;
                const ctx = chartInstance.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
                gradient.addColorStop(0, '#d2fffd'); // Strong color at the top
                gradient.addColorStop(0.2, '#e7f9f9'); // Strong color at the top
                gradient.addColorStop(0.3, '#fff'); // Fully transparent at the bottom
                this.setState({
                    chartData: {
                        ...this.state.chartData,
                        datasets: this.state.chartData.datasets.map((item) => ({
                            ...item,
                            backgroundColor: gradient,
                            fill: true,
                        })),
                    },
                });
            }
        }, 500);
    }

    render() {
        const options = {
            maintainAspectRatio: false,
            radius: 0,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        title: (yDatapoint) => {
                            if (this.props.dontShowLable) return null;
                            const date = moment(yDatapoint[0]?.label).format('ll').split(',')[0];

                            const title = this.props.titleType
                                ? this.props.titleType(date)
                                : `Week Start: ${date}`;

                            return title;
                        },
                        label: (yDatapoint) =>
                            `${this.props.keyName}: ${numeral(yDatapoint.raw).format('0.0a')}`,
                    },
                    displayColors: false,
                },
            },
            interaction: {
                mode: 'nearest',
                intersect: false,
            },
            elements: {
                point: {
                    radius: 0, // invisible point
                    hitRadius: 10, // increase clickable area
                    hoverRadius: 6, // increase area for hover effect
                },
            },
            devicePixelRatio: 3,
            scales: {
                x: {
                    ticks: {
                        display: false,
                    },
                    grid: {
                        drawBorder: false,
                        display: false,
                    },
                },
                y: {
                    type: 'logarithmic',
                    ticks: {
                        display: false,
                        beginAtZero: true,
                    },
                    grid: {
                        drawBorder: false,
                        display: false,
                    },
                },
            },
        };

        return (
            <div style={{ height: '55px', position: 'relative', paddingRight: '20px' }}>
                <Line data={this.state.chartData} options={options} ref={this.ref} />
            </div>
        );
    }
}

export default Sparkline;
